<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/E8xL2e/tc-custom/9781572846951.jpg?1704761579415" alt="This image is the cover for the book Diabetes Cooking 101, 101 Recipes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Diabetes Cooking 101, 101 Recipes
      </h1>
      <p class="bookDescription body article font2">
        <b>A diabetic-friendly collection in the series that serves up “delicious, healthful recipes that are easy to prepare and don’t scrimp on flavor and taste” (<i>Power Player Lifestyle</i>).</b><br/>  <br/> This cookbook features 101 tasty, diverse, and accessible recipes, all of which have been thoroughly kitchen tested. <i>Diabetes Cooking 101</i> will also feature a simple, contemporary-looking design that’s as practical as it is elegant, with measures calculated using both traditional and metric quantities. Scattered throughout are beautiful full-color photographs that enhance each books utility and visual appeal.<br/>  <br/><i>Diabetes Cooking 101</i> starts off with a detailed introduction that covers the basics of the book’s topic and provides plenty of helpful how-tos, insider tips, and keys to best results. The idea is to provide everything a reader needs to know in order to make these recipes successfully. The 101 recipes included feature a breadth of different dishes drawn from a wide range of culinary traditions, all of them featuring clear, straightforward directions, and all of them delicious. The 101 Series is perfect both for beginners and more experienced cooks looking to broaden their kitchen horizons.<br/>  <br/><b>101 Series</b><br/>  <br/> “A good resource to find creative recipes for any beginning vegan or for someone who’s been following that lifestyle for some time.” —WLS-ABC Chicago<br/>  <br/> “[<i>Slow Cooker 101</i>] has supremely easy recipes for busy cooks and has helpful insider tips for<br/> getting the best results from your recipes using a slow cooker.” —<i>Florida Sun-Sentinel</i><br/>  <br/> “Easy-to-use recipes with a side-order of photos . . . clear and concise . . . opens with a chapter on kitchen basics, including a list of equipment ‘must haves,’ a section most useful for beginner home cooks.” —<i>Insatiable</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Perrin Davis
      </h2>
      
      <p class="authorDescription body article"><B>Perrin Davis</B> is co-editor of Surrey's <I>101</I> series. She lives in suburban Chicago.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Agate Surrey
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d30f3d4